import React, { useEffect } from "react";
import { lazy, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalNavigate } from './services/navigationUtil';

import {
  createBrowserRouter,
  RouterProvider,
  Route,
  useNavigate,
} from "react-router-dom";
import Category from "./pages/Category";

import Details from "./pages/Details";
import Home,{loaderLocation} from "./pages/Home";
import Profile from "./pages/Profile";
import PushNotification from "./pages/PushNotification";
import Register from "./pages/Register";
import Spinner from "./pages/Spinner";
import Splash from "./pages/Splash";
import Subscription from "./pages/Subscription";
import { logoutAction} from "./redux/slices/authSlice";
import { listCategoryAction } from "./redux/slices/categoriesSlice";
import { usrAction} from "./redux/slices/usrSlice";


import {HOME_PATH,REGISTER_PATH,DETAILS_PATH, PROFILE_PATH, CATEGORY_PATH, LOGOUT_PATH, FORGOT_PWD_PATH, PUSH_NOTIFICATION_PATH, SUBSCRIPTION_PATH, CHANGE_PASSWORD_PATH, CHANGE_IMAGE_PATH, CHANGE_SERVICE_PATH, CHANGE_ADDRESS_PATH, SUBSCRIPTION_DETAILS_PATH, ABOUT_US_PATH, CONTACT_US_PATH, NOTIFCATION_PATH, REGISTER_GENERAL_PATH, MANAGE_SUBSCRIPTION_PLAN_PATH, MANAGE_NOTIFICATION_PATH, TNC_PATH, PRIVACY_POLICY_PATH, CHANGE_CATEGORY_ICON_PATH, HOME_SEARCH_PATH, USER_MANAGEMENT_PATH, CONTACT_US_MANAGEMENT_PATH, ANALYTICS_MANAGEMENT_PATH, FAVOURITES_PATH, DELETE_ACCOUNT_PATH} from "./utility/path";
import ChangePassword from "./pages/ChangePassword";
import ChangeImage from "./pages/ChangeImage";
import ChangeService from "./pages/ChangeService";
import ChangeAddress from "./pages/ChangeAddress";
import { setHeader } from "./redux/slices/headerSlice";
import SubscriptionDetails from "./pages/SubscriptionDetails";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import TnC from "./pages/TnC";
import Notification from "./pages/Notification";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import HomeSearch from "./pages/HomeSearch";

import Favourite from "./pages/Favourite";
import DeleteAccount from "./pages/DeleteAccount";

// import UserManagment from "./pages/UserManagment";
// import AnalyticsManagment from "./pages/AnalyticsManagment";
// import ContactUsManagment from "./pages/ContactUsManagment";
// import ManageSubscriptionPlan from "./pages/ManageSubscriptionPlan";
// import ManageNotification from "./pages/ManageNotification";
// import ChangeCategoryIcon from "./pages/ChangeCategoryIcon";

const UserManagment        = lazy(() => import("./pages/UserManagment"));
const AnalyticsManagment   = lazy(() => import("./pages/AnalyticsManagment"));
const ContactUsManagment   = lazy(() => import("./pages/ContactUsManagment"));
const ManageSubscriptionPlan = lazy(() => import("./pages/ManageSubscriptionPlan"));
const ManageNotification   = lazy(() => import("./pages/ManageNotification"));
const ChangeCategoryIcon   = lazy(() => import("./pages/ChangeCategoryIcon"));


function NavigationSetter() {
  const navigate = useNavigate();

  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);

  return null; // This component doesn't render anything
}

function App() {
  const dispatch = useDispatch();

  const splash = useSelector(state => state?.splash?.value);
  const spinner = useSelector(state => state?.spinner?.value);
  
  const router = createBrowserRouter([
    {
      path: HOME_PATH,
      element: (
      <>
        <NavigationSetter /> {/* This captures the navigate function */}
        <Home />
      </>),
    //  loader: ()=>{
    //   //loaderLocation();
    //   //dispatch(usrAction({}));
    //   //dispatch(listCategoryAction({}));
    //   return null;
    //   ;
    //  }
    },{path: HOME_SEARCH_PATH, element: <HomeSearch/>},
    // {
    //   path: LOGIN_PATH,
    //   element: <Register/>,
    // },
    {
      path: REGISTER_PATH,
      element: <Register/>,
      loader: ()=>{
        //localStorage.removeItem("userInfo");
        //localStorage.removeItem("location");
        //dispatch(logoutAction({}));
        return {vendor:false};
      }
    },
    {
      path: REGISTER_GENERAL_PATH,
      element: <Register/>,
      loader: ()=>{
        //localStorage.removeItem("userInfo");
        //localStorage.removeItem("location");
        //dispatch(logoutAction({}));
        return {vendor:true};
      }
    },
    {
      path: DETAILS_PATH,
      element: <Details/>,
    },
    {
      path: PROFILE_PATH,
      element: <Profile/>,
    },
    {
      path: CATEGORY_PATH,
      element: <Category/>,
    },
    {
      path: PUSH_NOTIFICATION_PATH,
      element: <PushNotification/>,
    },
    {
      path: SUBSCRIPTION_PATH,
      element: <Subscription/>,
    },
    {
      path: MANAGE_SUBSCRIPTION_PLAN_PATH,
      element: <ManageSubscriptionPlan/>,
    },
    {
      path: MANAGE_NOTIFICATION_PATH,
      element: <ManageNotification/>,
    },
    {
      path: LOGOUT_PATH,
      element: <Register/>,
      loader: ()=>{
        return null;
      }
    },{
      path: FORGOT_PWD_PATH,
      element: <Register/>,
      loader: ()=>{
        return null;
      }
    },{
      path: CHANGE_ADDRESS_PATH,element: <ChangeAddress/>,loader: ()=>{return dispatch(setHeader({gotoName:"Profile",gotoAction:PROFILE_PATH}));null;}
    },{
      path: CHANGE_PASSWORD_PATH,element: <ChangePassword/>,loader: ()=>{return dispatch(setHeader({gotoName:"Profile",gotoAction:PROFILE_PATH}));null;}
    },{
      path: CHANGE_IMAGE_PATH,element: <ChangeImage/>,loader: ()=>{return dispatch(setHeader({gotoName:"Profile",gotoAction:PROFILE_PATH}));null;}
    },{
      path: CHANGE_CATEGORY_ICON_PATH,element: <ChangeCategoryIcon/>,loader: ()=>{return dispatch(setHeader({gotoName:"Category",gotoAction:CATEGORY_PATH}));null;}
    },{
      path: CHANGE_SERVICE_PATH,element: <ChangeService/>,loader: ()=>{return dispatch(setHeader({gotoName:"Profile",gotoAction:PROFILE_PATH}));null;}
    },{
      path: SUBSCRIPTION_DETAILS_PATH,element: <SubscriptionDetails/>,loader: ()=>{return dispatch(setHeader({gotoName:"Subscription",gotoAction:SUBSCRIPTION_PATH}));null;}
    },{
      path: CONTACT_US_PATH,element: <ContactUs/>,loader: ()=>{return null;}
    },{
      path: ABOUT_US_PATH,element: <AboutUs/>,loader: ()=>{return null;}
    },{
      path: TNC_PATH,element: <TnC/>,loader: ()=>{return null;}
    },{
      path: NOTIFCATION_PATH,element: <Notification/>,loader: ()=>{return null;}
    },{
      path: PRIVACY_POLICY_PATH,element: <PrivacyPolicy/>,loader: ()=>{return null;}
    },{
      path: USER_MANAGEMENT_PATH,element: <UserManagment/>,loader: ()=>{return null;}
    },{
      path: CONTACT_US_MANAGEMENT_PATH,element: <ContactUsManagment/>,loader: ()=>{return null;}
    },{
      path: ANALYTICS_MANAGEMENT_PATH,element: <AnalyticsManagment/>,loader: ()=>{return null;}
    },{
      path: FAVOURITES_PATH,element: <Favourite/>,loader: ()=>{return null;}
    },{
      path: DELETE_ACCOUNT_PATH,element: <DeleteAccount/>,loader: ()=>{return dispatch(setHeader({gotoName:"Profile",gotoAction:PROFILE_PATH}));null;}
    }
  ]);

  return (
    <>
      {splash ? <Splash /> : (<Suspense fallback={<Splash />}>
        <RouterProvider router={router} />
      </Suspense>)}
      {spinner ? <Spinner/> : ""}
      
    </>
    
  );
} 

export default App;
